import React from 'react'
import Box from '@material-ui/core/Box'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { Typography } from '@material-ui/core'

export const ConfirmationItem = ({head, body}) => {
  const classes = useStyles();
  return (
    <Box className={[classes.wrapper, "confirmation-item-wrapper"].join(' ')}>
      <Typography className="confirmation-item-head">
        {head}
      </Typography>
      <Typography className="confirmation-item-body">
        {body}
      </Typography>
    </Box>
  )
}

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '0.25rem 0'
  }
})